<sb-card>
  <div card-header>
    {{ 'nav.network.devices.details.networkAccess' |translate }}
    @if (sharedNetworkAccesses()?.length > 1) {
      {{ currentPlaylist }}
    }
  </div>
  <div card-header-more class="tw-flex">
    @if (sharedNetworkAccesses()?.length > 1) {
      <div class="tw-flex tw-items-center">
        <sb-icon (click)="e?.prev()" class="tw-mx-1 tw-cursor-pointer blue" icon="arrowLeftAlt">
        </sb-icon>
        {{ currentPlaylist }} {{ 'lang.globals.of' | translate }} {{ sharedNetworkAccesses()?.length }}
        <sb-icon (click)="e?.next()" class="tw-mx-1 tw-cursor-pointer blue" icon="arrowRightAlt">
        </sb-icon>
      </div>
    }
  </div>
  <div card-body>

    <ngb-carousel #e (slide)="currentPlaylist = $event.current" [activeId]="currentPlaylist" [interval]="-1" [keyboard]="false"
                  [showNavigationArrows]="false" [showNavigationIndicators]="false" [wrap]="true">
      @for (networkAccess of sharedNetworkAccesses(); track $index; let i = $index) {
        <ng-template id="{{i+1}}" ngbSlide>
          <div class="tw-grid tw-grid-cols-4 tw-gap-3">
            @if (!isInDeviceContext()) {
              <div>
                <h3>
                  Info
                </h3>
                <div class="tw-flex tw-flex-row">
                  <div class="tw-flex tw-flex-col tw-justify-start">
                    <!--
                    <div class="m-3 d-flex" *ngIf="sharedPlaylist?.playlist?.schedule">
                      <sb-icon class="mr-2" icon="schedules"></sb-icon>
                      {{ 'lang.schedules.schedule'|translate }}:
                      {{ sharedPlaylist?.playlist?.schedule?.name }}
                    </div>
                    -->
                    <div class="tw-m-3 tw-flex" [class.tw-pointer-events-none]="isInDeviceContext()">
                      <a (click)="showScreensModal(networkAccess?.screens)">
                        <sb-icon class="mr-2" icon="screen"></sb-icon>
                        {{ 'lang.globals.screens'|translate }}:
                        {{ networkAccess?.screens?.length }}
                      </a>
                    </div>
                    <!--
                    <div class="tw-m-3 tw-flex">
                      <a (click)="showDateTimeRanges(assignment?.ranges)">
                        <sb-icon class="tw-mr-2" icon="calendar"></sb-icon>
                        {{ 'lang.globals.timeRanges'|translate }}:
                        {{ assignment?.ranges?.length }}
                      </a>
                    </div>
                    -->
                  </div>
                </div>
                <!--
                <div class="tw-flex tw-mt-2 tw-flex-col tw-justify-start">
                  @for (range of assignment?.ranges; track $index) {
                    <div
                      class="d-flex my-1 mx-3 border-dashed-bottom"
                      container="body"
                      [ngbTooltip]="util.calculateTimespanBetweenDates(range?.from, range?.till)"
                    >
                      {{ util.dateToDateTimeString(range?.from?.value) }}  -  {{ util.dateToDateTimeString(range?.till?.value) }}
                    </div>
                  }
                </div>
                -->
              </div>
            }
            <div class="" [ngClass]="isInDeviceContext() ? 'tw-col-span-4' : 'tw-col-span-3'">
              @let transposedClientNetworkAccess = transposeData(networkAccess.clientNetworkAccesses);
              @if (transposedClientNetworkAccess) {
                <div class="tw-overflow-x-auto">
                  <table class="table table-hover ">
                    <thead>
                    <tr>
                      <th>

                      </th>
                      @for (client of networkAccess.clientNetworkAccesses; track $index) {
                        <th>
                          <sb-comp-image-name-wrapper
                            [image]="client.client?.primaryCompany?.logo?.url"
                            [customHeight]="'30px'"
                            [customWidth]="'30px'">
                            <div firstLine>
                              {{ client?.client?.name }}

                            </div>
                          </sb-comp-image-name-wrapper>
                        </th>
                      }
                      <!--
                      <th>
                        {{ 'lang.networkShare.bookable' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.subletable' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.showOnlineStatus' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.showLogs' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.showPlayouts' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.showPlaylist' | translate }}
                      </th>
                      <th>
                        {{ 'lang.globals.bookings' | translate }} - {{ 'lang.networkShare.accessOption.Manage' | translate }}
                      </th>
                      <th>
                        {{ 'lang.globals.bookings' | translate }} - {{ 'lang.networkShare.accessOption.Read' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.templateData' | translate }} - {{ 'lang.networkShare.accessOption.Manage' | translate }}
                      </th>
                      <th>
                        {{ 'lang.networkShare.templateData' | translate }} - {{ 'lang.networkShare.accessOption.Read' | translate }}
                      </th>
                      <th class="tr">
                      </th>
                      -->
                    </tr>
                    </thead>
                    <tbody>
                      @for (transposed of transposedClientNetworkAccess; track $index) {
                        <tr>
                          <td>
                            {{ transposed?.label }}
                          </td>
                          @for (value of transposed.values; track $index) {
                            <td class="tw-text-center">
                              <sb-network-share-option-status [option]="value"></sb-network-share-option-status>
                            </td>
                          }
                          <!--
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.subletable"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.onlineStatusAccess"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.logAccess"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.playoutAccess"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.playlistAccess"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.bookingManage"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.bookingRead"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.templateEntryManage"></sb-network-share-option-status>
                          </td>
                          <td>
                            <sb-network-share-option-status
                              [option]="transposed?.accessPattern?.templateEntryRead"></sb-network-share-option-status>
                          </td>
                          -->
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else {
                {{ 'lang.globals.noData' | translate }}
              }

            </div>
          </div>
        </ng-template>
      } @empty {
        {{ 'lang.globals.noData' | translate }}
      }
    </ngb-carousel>
  </div>
</sb-card>
